/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  AvailableIncidentFiltersResponseDto,
  IncidentStatisticsResponseDto,
  IncidentsControllerV2FindAllV2200AllOf,
  IncidentsControllerV2FindAllV2Params,
  IncidentsControllerV2FindAllV2PathParameters,
  IncidentsControllerV2GetAvailableFiltersV2Params,
  IncidentsControllerV2GetAvailableFiltersV2PathParameters,
  IncidentsControllerV2GetStatisticsV2Params,
  IncidentsControllerV2GetStatisticsV2PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class IncidentsV2Service {
  private readonly http = inject(HttpClient);
  /**
   * Returns a paginated, filtered, sorted list of incidents for the incidents grid.
   * @summary Get incidents
   */

  findAll<TData = IncidentsControllerV2FindAllV2200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: IncidentsControllerV2FindAllV2PathParameters,
    params?: IncidentsControllerV2FindAllV2Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/incidents/v2/clients/${clientId}/incidents`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Returns aggregated statistics for incidents based on the provided filters.
   * @summary Get incident statistics
   */

  getStatistics<TData = IncidentStatisticsResponseDto>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: IncidentsControllerV2GetStatisticsV2PathParameters,
    params?: IncidentsControllerV2GetStatisticsV2Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/incidents/v2/clients/${clientId}/incidents/statistics`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Distinct severity/deviceType/building/floor/room values for open incidents, without fetching full rows
   * @summary Get available incident filters
   */

  getAvailableFilters<TData = AvailableIncidentFiltersResponseDto>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: IncidentsControllerV2GetAvailableFiltersV2PathParameters,
    params?: IncidentsControllerV2GetAvailableFiltersV2Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/incidents/v2/clients/${clientId}/incidents/filters`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
